export default __webpack_public_path__ + "static/media/photo--lg--kara7.4c13f6fd.jpg";